import React, { useState, useCallback, useRef } from 'react'
import { useMount } from 'react-use'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Input, Icon, Spin, message, Empty, Tabs } from 'antd'
import styles from './globalSearch.module.scss'
import * as actions from '@/models/globalSearch/actions'
import * as apis from '@/apis'
import RenderItem from './RenderItem'
import debounce from 'lodash/debounce'

export default function GlobalSearch(props) {
  const [keyword, setKeyword] = useState('')
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [result, setResult] = useState([])
  const [subView, setSubview] = useState(null)
  const [tab, setTab] = useState('orders')
  const SubViewInstance = useRef(null)

  const searchByKeyword = useRef(debounce((_index, _keyword) => {
    setLoading(true)
    return apis.searchByIndex(_index || tab, {
        w: _keyword || keyword
      })
      .then(res => {
        setLoading(false)
        setResult(res.data)
        setTotal(res.total)

        return res
      })
      .catch(error => {
        setLoading(false)
        message.error(error.message || '服务异常')
      })
  }, 500), [tab, keyword]).current

  const onChangeHandler = useCallback(event => {
    const { value } = event.target
    setKeyword(value)
    searchByKeyword(tab, value)
  }, [tab])
  const clearKeyword = useCallback(() => {
    setKeyword('')
  }, [])
  const backMainView = useCallback(() => {
    SubViewInstance.current = null
    setSubview(null)
  })
  const gotoSubView = useCallback(payload => {
    const { view, ...data } = payload
    SubViewInstance.current = view
    setSubview(data)
  }, [])
  const onTabChange = useCallback(_tab => {
    setResult([])
    setTab(_tab)
    searchByKeyword(_tab, keyword)
  }, [keyword])

  return (
    <div className={styles.globalSearch}>
      <label className={styles.header}>
        {
          subView ? (
            <div className={styles.subViewTitle}>
              <div
                onClick={backMainView}
                className={classnames('iconfont', styles.icon, styles.backIcon)}>&#xe62a;</div>
              <div className={styles.title}>{subView.title}</div>
            </div>
          ) : (
            <div className={styles.mainViewTitle}>
              <div className={classnames('iconfont', styles.icon, styles.searchIcon)}>&#xe60d;</div>
              <Input
                placeholder="搜索"
                className={styles.input}
                autoFocus
                value={keyword}
                size="large"
                onChange={onChangeHandler} />
            </div>
          )
        }
        {
          loading && (
            <div className={styles.loading} />
          )
        }
        {
          !loading && !subView && keyword.length > 0 && (
            <span className={styles.clearBtn} onClick={clearKeyword}>清空</span>
          )
        }
        <div
          onClick={props.close}
          className={classnames('iconfont', styles.closeBtn)}>&#xe6ac;</div>
      </label>
      {/* {
        !subView && (
          <Tabs className={styles.tabs} defaultActiveKey={tab} onChange={onTabChange}>
            <Tabs.TabPane tab="工单" key="orders" />
            <Tabs.TabPane tab="聊天记录" key="messages" />
          </Tabs>
        )
      } */}
      <div className={styles.resultWrap}>
        <Spin spinning={loading} className={styles.resultLoading}></Spin>
          {
            result.length === 0 && (
              <Empty
                image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
                imageStyle={{
                  height: 120,
                }}
                className={styles.empty}
                description={
                  keyword.length !== 0 ? (
                    <div style={{fontSize: 14, paddingTop: 30}}>没有搜索到内容<br />您可以换一个关键字试试</div>
                  ) : (
                    <div style={{fontSize: 14, paddingTop: 30, color: '#ccc'}}>请输入关键字搜索</div>
                  )
                }>
              </Empty>
            )
          }
          {
            !subView && result.map((item, idx) => (
              <RenderItem
                type={tab}
                onClick={gotoSubView}
                key={idx}
                keyword={keyword}
                data={item} />
            ))
          }
          {
            subView && React.cloneElement(SubViewInstance.current)
          }
      </div>
    </div>
  )
}
